<script setup lang="ts">
import {Activity, Calendar, HeartPulse, Phone, ShieldPlus, Smartphone} from "lucide-vue-next";

import "@/assets/styles/home.css";
</script>

<template>
  <div class="home">

    <!-- HERO -->
    <section class="hero">

      <div class="hero-overlay"></div>

      <div class="hero-content">

        <span class="hero-badge">
          Ambulante Pflege & Betreuung
        </span>

        <h1>
          Fürsorge, die<br/>
          von Herzen kommt
        </h1>

        <p>
          Menschliche Pflege, medizinische Betreuung und persönliche Unterstützung
          für ein sicheres Leben zuhause.
        </p>

        <div class="hero-buttons">

          <router-link to="/contact" class="primary-btn">
            <Calendar/>
            Pflegeberatung anfragen
          </router-link>

          <a href="tel:+4906975009899" class="secondary-btn">
            <Phone/>
            Jetzt anrufen
          </a>

          <a
              href="https://wa.me/491702177193"
              target="_blank"
              rel="noopener"
              class="whatsapp-btn"
          >
            <Smartphone/>
            Kontakt über WhatsApp
          </a>

        </div>

      </div>

    </section>

    <!-- LEISTUNGEN -->
    <section class="services-preview">

      <div class="section-header">
        <span>Unsere Leistungen</span>
        <h2>Professionelle Pflege mit Herz</h2>
      </div>

      <div class="services-grid">

        <router-link to="/services" class="service-card">

          <div class="service-icon">
            <HeartPulse/>
          </div>

          <h3>SGB XI – Pflegeleistungen</h3>

          <p>
            Unterstützung im Alltag und bei der häuslichen Pflege – individuell, zuverlässig und auf die persönlichen
            Bedürfnisse abgestimmt. Dazu gehören pflegerische Hilfen, Entlastungsangebote sowie die Betreuung von
            pflegebedürftigen Menschen im häuslichen Umfeld.
          </p>
        </router-link>


        <router-link to="/services" class="service-card">
          <div class="service-icon">
            <Activity/>
          </div>


          <h3>SGB V – Behandlungspflege</h3>

          <p>
            Medizinische Versorgung nach ärztlicher Verordnung direkt bei Ihnen zuhause. Wir übernehmen professionelle
            behandlungspflegerische Maßnahmen mit fachlicher Kompetenz, Sorgfalt und persönlicher Betreuung.
          </p>
        </router-link>


        <router-link to="/services" class="service-card">
          <div class="service-icon">
            <ShieldPlus/>
          </div>

          <h3>Beratung & Unterstützung</h3>

          <p>
            Kompetente Beratung rund um Pflegegrade, Pflegeleistungen und Einstufungsgespräche. Wir begleiten
            Angehörige
            und Betroffene zuverlässig bei organisatorischen und pflegerischen Fragen.
          </p>
        </router-link>


      </div>


    </section>

    <!-- ÜBER UNS -->
    <section class="about-preview">

      <div class="about-left">

        <span class="section-badge">
          Über uns
        </span>

        <h2>
          Pflege bedeutet Vertrauen,
          Respekt und Menschlichkeit
        </h2>

        <p>
          Seit vielen Jahren begleiten wir Menschen
          im Alltag und unterstützen Familien
          mit zuverlässiger ambulanter Pflege.
        </p>

        <p>
          Unser Ziel ist es, Menschen ein würdevolles,
          sicheres und selbstbestimmtes Leben
          in ihrer gewohnten Umgebung zu ermöglichen.
        </p>

        <router-link to="/about" class="about-btn">
          Mehr erfahren
        </router-link>

      </div>

      <div class="about-right">

        <img
            src="../assets/blutdruck.png"
            alt="Pflegedienst Team"
        />

      </div>

    </section>

    <!-- KONTAKT -->
    <section class="contact-banner">

      <div class="contact-wrapper">

        <!-- LEFT -->
        <div class="contact-info">

      <span class="section-badge">
        Kontakt
      </span>

          <h2>
            Wir sind persönlich für Sie da
          </h2>

          <p class="contact-text">
            Kontaktieren Sie uns telefonisch oder besuchen Sie uns
            an unserem Servicebüro in der Herxheimer-Straße.
          </p>

          <!-- Standort 1 -->
          <div class="location-card">

            <h3>
              Standort 1 – Verwaltung
            </h3>

            <p>Am Niedwald 53</p>
            <p>65933 Frankfurt am Main</p>

            <span>
          Postanschrift und Schriftverkehr
        </span>

          </div>

          <!-- Standort 2 -->
          <div class="location-card">

            <h3>
              Standort 2 – Servicebüro
            </h3>

            <p>Herxheimerstraße 17</p>
            <p>60326 Frankfurt am Main</p>

            <span>
          Kundenempfang und Beratung
        </span>

          </div>

        </div>

        <!-- RIGHT -->
        <div class="contact-side">

          <div class="contact-side-card">

            <h3>Telefon</h3>

            <a href="tel:+4906975009899">
              069 7500 9899
            </a>

          </div>

          <div class="contact-side-card">

            <h3>Öffnungszeiten</h3>

            <ul>
              <li>
                <span>Mo. – Mi.</span>
                <span>10:00 – 16:00 Uhr</span>
              </li>

              <li>
                <span>Weitere Termine</span>
                <span>nach Vereinbarung</span>
              </li>
            </ul>

          </div>

        </div>

      </div>

    </section>
  </div>
</template>

<style scoped>
</style>